import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import countryService from "../../services/countryService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const countryFormSchema = [
  {
    name: "countryName",
    label: "Country Name",
    type: "text",
    placeholder: "e.g. India",
    validation: { required: true },
  },
  {
    name: "countryCode",
    label: "Country Code",
    type: "text",
    placeholder: "e.g. IN",
    validation: { required: true },
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function CountryCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await countryService.createCountry(values);
      alertService.success("Country created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Country">
      <CrudForm
        mode="create"
        schema={countryFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default CountryCreateModal;
